
import { Sale } from "@/models/base";
import Vue from "vue";
export default Vue.extend({
	props: {
		sale: {
			type: Object as () => Sale,
			required: true
		}
	},
	computed: {
		currencySymbol(): string {
			return this.sale.Currency?.Prefix || "€";
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
